'use strict';

angular.module('amexReconciliationApp')
  .component('poDataButton', {
    templateUrl: 'scripts/views/components/po-data-button.html',
    controller: function ($rootScope,
                          $uibModal,
                          SelectedTransactionService,
                          AssociateAccountingDetailsRepository,
                          ActiveTransactionModel,
                          TransactionSearchModel,
                          TransactionsModel) {
      var self = this;

      self.showButton = function() {
        return !TransactionSearchModel.isLimitedRole();
      };

      self.anyTransactions = function () {
        return SelectedTransactionService.selectedTransactionsCount() > 0 || ActiveTransactionModel.hasActiveTransaction();
      };

      self.buttonText = function () {
        if (self.anyTransactionLinked()) {
          return 'transactions.UnlinkPoDataButton';
        } else {
          return 'transactions.PoDataButton';
        }
      };

      self.anyTransactionLinked = function () {
        return _.some(transactions(), function (o) {
          return o.transactionThirdPartyData && o.transactionThirdPartyData.length > 0;
        });
      };

      self.buttonAction = function () {
        if (self.anyTransactionLinked()) {
          var selectedTransactionIds = _.map(transactions(), 'id');
          AssociateAccountingDetailsRepository.unlink(selectedTransactionIds).then(function () {
            return TransactionsModel.refreshTransactions(selectedTransactionIds);
          });
        } else {
          self.openPoData();
        }
      };

      self.openPoData = function openPoData() {
        var scopeWithTransactions = $rootScope.$new();
        scopeWithTransactions.transactions = transactions();
        $uibModal.open({
          template: '<po-data-modal transactions="transactions" close-modal-callback="$close()"></po-data-modal>',
          windowTemplateUrl: 'scripts/views/modals/fixed-window-template.html',
          size: 'xlg',
          scope: scopeWithTransactions
        });
      };

      function transactions() {
        if (ActiveTransactionModel.hasActiveTransaction()) {
          return [ActiveTransactionModel.activeTransaction()];
        } else {
          return SelectedTransactionService.selectedTransactions();
        }
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/poDataButton.js
// module id = 464
// module chunks = 0